module.exports = __webpack_public_path__ + "static/img/1088_small.0fc680e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1088_small.png
// module id = 5+Ze
// module chunks = 1